import axios from 'axios';
import { API_URL } from './baseApi';

export const birthdayApi = {
  sendBirthdayCoins: async () => {
    return await axios.post(`${API_URL}/v1/birthday-awards`);
  },
};
